export enum RoleNames {
    'SEND_REFERRAL' = 'CreateUploadLeads',
    'VIEW_REPORT' = 'CommissionReport',
    'MANAGE_USERS' = 'ManageUser',
    'VIEW_DASHBOARD' = 'ViewReport'
}
